var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "300", color: "white" },
      model: {
        value: _vm.popupData.show,
        callback: function($$v) {
          _vm.$set(_vm.popupData, "show", $$v)
        },
        expression: "popupData.show"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "px-3 py-3" },
        [
          _vm._t("message"),
          _c(
            "v-btn",
            {
              staticClass: "font-weight-bold text-capitalize",
              attrs: { block: "", color: "error" },
              on: {
                click: function($event) {
                  return _vm.ok()
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.okText || "Ok") + " ")]
          ),
          !_vm.hideCancel
            ? _c(
                "v-btn",
                {
                  staticClass: "font-weight-bold text-capitalize mt-2",
                  staticStyle: { color: "#ff5252" },
                  attrs: { block: "", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.noText || "No") + " ")]
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }